import React, { useState } from 'react';
import './Experience.css';

const experiences = [
  {
    title: "Software Developer Intern – Decorwale",
    duration: "April 2024 – June 2024 , Remote Work",
    description: `*Built and maintained responsive web pages using HTML, CSS, JavaScript, and Reactjs. 

    *Improved UI design and fixed layout bugs for better user experience across devices.

    *Collaborated with developers using Git and GitHub for version control. 

    *Integrated APIs using Axios to fetch and display dynamic content.

    *Followed branding guidelines to create clean, consistent UI components.`
  },
  {
    title: "Full Stack Developer Intern – ELS",
    duration: "Jan 2024 – Mar 2024 , Remote Work",
    description: "Built the company's website from scratch using MERN stack, deployed it, and maintained version control using Git. Integrated backend APIs and ensured full responsiveness.",
  },
  {
    title: "Social Intern – Martha Farrell Foundation",
    duration: "June 2023 – Aug 2023 , OnSite Work",
    description: "Worked as a UI Designer creating interactive layouts, conducted user research, and contributed to design consistency across web platforms and campaigns.",
  },
];

const Experience = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(prev => prev === index ? null : index);
  };

  return (
    <section id="experience">
      <h1 className="experience-heading">EXPERIENCE.</h1>
      <div className="vertical-line"></div>
      <div className='black'>
      <div className="numberline-container">
        {experiences.map((exp, index) => (
          <div
            key={index}
            className={`numberline-entry ${hoveredIndex === index ? 'hovered' : ''}`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => toggleExpand(index)}
          >
            <div className="dot"></div>
            <div className="numberline-title">{exp.title}</div>
            <div className="numberline-desc">{exp.duration}</div>
            {expandedIndex === index && (
              <div className="numberline-detail">
                <p>{exp.description}</p>
              </div>
            )}
          </div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
